import { validateContentReference } from '@gitbook/app-content-refs';
import { Schema } from '@gitbook/slate';

import { BLOCK_IF, BLOCK_OPENAPI_SCHEMAS } from '../types';

const validateOpenApiRef = validateContentReference(['openapi']);

/*
 * Schema to validate OpenAPI Schemas blocks.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_OPENAPI_SCHEMAS]: {
            parent: { objects: ['document', 'block'], types: [undefined, BLOCK_IF] },
            isVoid: true,
            data: {
                ref: (data: unknown) => validateOpenApiRef(data),
                schemas: (data: unknown) => typeof data === 'object' && Array.isArray(data),
                grouped: (data: unknown) =>
                    typeof data === 'boolean' || typeof data === 'undefined',
            },
        },
    },
});
